import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type MutationProps = {
	companyId: string;
	templateId: string;
};

const useDeleteFeeTemplateMutation = (feeTemplateDelete: Function, onSuccess?: Function) => {
	const dispatch = useDispatch();

	return useMutation(
		({ companyId, templateId}: MutationProps) => {
			return feeTemplateDelete({
				companyId,
				templateId
			});
		},
		{
			onSuccess() {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useDeleteFeeTemplateMutation;
